// extracted by mini-css-extract-plugin
module.exports = {"Abundance":"Abundance___1d3bh","AbundanceBadge":"AbundanceBadge___yHcUx","loading":"loading___3_wPl"};